import { render, staticRenderFns } from "./HomeRedirector.vue?vue&type=template&id=00c751d0&scoped=true&"
import script from "./HomeRedirector.vue?vue&type=script&lang=js&"
export * from "./HomeRedirector.vue?vue&type=script&lang=js&"
import style0 from "./HomeRedirector.vue?vue&type=style&index=0&id=00c751d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c751d0",
  null
  
)

export default component.exports